import { useMutation } from "react-query"
import api from "../../client"
import { AddressBookUpdatePayload, AddressBookUpdateResponseData } from "../../types/address-book"

const putData = async (uuid: string | undefined, payload: AddressBookUpdatePayload) => {
    const { data } = await api.put<AddressBookUpdateResponseData>(
        `/address-book/${uuid}`,
        payload
    )
    return data
}

export const useAddressBookUpdate = (uuid: string | undefined) => {
    return useMutation((payload: AddressBookUpdatePayload) => {
        return putData(uuid, payload)
    })
}
